import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "./cards.css";
import CardsPage from "../../../components/CardsPage/CardsPage";
import NoCardPage from "../../../components/CardsPage/NoCardPage";
import CreateCard1 from "./CreateCard.js/CreateCard1";
import CreateCard2 from "./CreateCard.js/CreateCard2";
import FundCard from "./CreateCard.js/CreateCard3";
import CreateCardAddress from "./CreateCard.js/CreateCardAddress";
import FundCard2 from "./CardOptions/FundCard";
import TopNav from "../TopNav";
import CardReview from "./CreateCard.js/CreateCard4";
import NewCard from "./CreateCard.js/NewCard";
import CardOptions from "./CardOptions";
import FundSuccess from "./CardOptions/FundSuccess";
import CardTransactions from "./CardOptions/CardTransactions";
import CardWithdraw from "./CardOptions/CardWithdraw";
import ChangePin from "./CardOptions/ChangePin";
import BillingAddress from "./CardOptions/BillingAdrdess";
import ActivityLogs from "./ActivityLogs";
import CardDetails from "./CardOptions/CardDetails";
import ComingSoon from "../../../components/ComingSoon/ComingSoon";

const Cards = ({ toggleSidebar, handleCloseSidebar, userDetails }) => {
  const location = useLocation();

  const getTitle = () => {
    // if (location.pathname.startsWith("/user/cards/card_option/")) {
    //   return "Fund Your Card";
    // }
    // if (location.pathname.startsWith("/user/cards/")) {
    //   const parts = location.pathname.split("/");
    //   if (parts.length === 4 && parts[3]) {
    //     return "Card Actions"; 
    //   }
    // }
    if (location.pathname.includes("/user/cards/card_option/")) {
      if (location.pathname.includes("transactions")) return "Card Activity";
      if (location.pathname.includes("withdraw")) return "Withdraw";
      if (location.pathname.includes("change_pin")) return "Change Card Pin";
      // if (location.pathname.includes("billing_address")) return "Billing Address";
      if (location.pathname.includes("details")) return "Card Details";
      if (location.pathname.endsWith("/success")) return "Fund Card";
      return "Card Options";
    }
    
    if (location.pathname.includes("/user/cards/activity-logs")) return "Card Activity Logs";

    switch (location.pathname) {
      case "/user/cards/step1":
        return "Create New Card <small> - Choose Card </small>";
      case "/user/cards/step2":
        return "Customize Your Card";
      case "/user/cards/fund_card":
        return "Fund Your Card";
      // case "/user/cards/billing_address":
      //   return "Card Purpose";
      case "/user/cards/review_card":
        return "Review Your Card";
      case "/user/cards/new_card_display":
        return "Your New Card";
      default:
        return "Cards";
    }
  };

  const comingSoon = false;
  

  return (
    <>
      <TopNav title={getTitle()} userDetails={userDetails} toggleSidebar={toggleSidebar} />
      <section className="main p-2 cards__page">
        <div className="container-fluid p-0">
          
          
          <section className="wrapper__content" onClick={handleCloseSidebar}>
            <Routes>
              <Route index element={comingSoon ? <ComingSoon /> : <CardsPage userDetails={userDetails} />} />
              <Route path="step1" element={<CreateCard1 />} />
              <Route path="step2" element={<CreateCard2 />} />
              <Route path="fund_card" element={<FundCard userDetails={userDetails} />} />
              <Route path="billing_address" element={<CreateCardAddress />} />
              <Route path="review_card" element={<CardReview userDetails={userDetails} />} />
              <Route path="new_card_display" element={<NewCard userDetails={userDetails} />} />
              <Route path=":cardId" element={<CardOptions userDetails={userDetails} />} />
              <Route path="card_option/:cardId" element={<FundCard2 userDetails={userDetails} />} />
              <Route path="card_action/success" element={<FundSuccess userDetails={userDetails} />} />
              <Route path="card_option/:cardId/transactions" element={<CardTransactions userDetails={userDetails} />} />
              <Route path="card_option/:cardId/withdraw" element={<CardWithdraw userDetails={userDetails} />} />
              <Route path="card_option/:cardId/change_pin" element={<ChangePin userDetails={userDetails} />} />
              <Route path="card_option/:cardId/billing_address" element={<BillingAddress userDetails={userDetails} />} />
              <Route path="card_option/:cardId/details" element={<CardDetails />} />
              <Route path="activity-logs" element={<ActivityLogs />} />
            </Routes>
          </section>
          
        </div>
      </section>
    </>
  );
};

export default Cards;
